import { z } from 'zod';
import { passwordSchema } from './auth.js';
import { uuidSchema } from './common.js';
/**
 * The owner's team screen and the invite flow — features/TEAM.md.
 *
 * A manager runs exactly one location, so an invite names it. The role is not
 * an input: MANAGER is the only role an invite can grant. Ownership is never
 * handed out by email.
 */
export const createInviteSchema = z.strictObject({
    email: z.string().trim().toLowerCase().max(254).pipe(z.email()),
    locationId: uuidSchema,
});
/**
 * `POST /auth/invites/accept`. Token bounds as for a password reset: the token
 * is 43 base64url characters, and "invalid" is decided by the lookup.
 */
export const acceptInviteSchema = z.strictObject({
    token: z.string().trim().min(16).max(256),
    fullName: z.string().trim().min(1).max(120),
    password: passwordSchema,
});
export const inviteTokenSchema = z.string().trim().min(16).max(256);
export const teamMemberSchema = z.object({
    id: uuidSchema,
    email: z.string(),
    fullName: z.string(),
    role: z.enum(['OWNER', 'MANAGER']),
    locationId: uuidSchema.nullable(),
    locationName: z.string().nullable(),
    lastLoginAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
export const pendingInviteSchema = z.object({
    id: uuidSchema,
    email: z.string(),
    locationId: uuidSchema,
    locationName: z.string(),
    expiresAt: z.iso.datetime(),
    createdAt: z.iso.datetime(),
});
/**
 * `POST /team/invites`. `emailSent` is false when the provider refused or the
 * address is not on the test allowlist — the owner should know the link did
 * not go out rather than wait for a manager who never got it.
 */
export const createInviteResponseSchema = pendingInviteSchema.extend({
    emailSent: z.boolean(),
});
export const teamResponseSchema = z.object({
    members: z.array(teamMemberSchema),
    invites: z.array(pendingInviteSchema),
});
/** `GET /auth/invites/:token` — just enough for the invitee to know it is real. */
export const invitePreviewSchema = z.object({
    organizationName: z.string(),
    locationName: z.string(),
    email: z.string(),
});
//# sourceMappingURL=team.js.map